<section class="reporte-proyecto-page">
  <div class="table-page__toolbar table-page__toolbar--filters">
    <div class="table-page__filters-grid">
      <div class="table-page__filter table-page__filter--wide">
        <mat-form-field appearance="outline" class="table-page__field">
          <mat-label>Proyecto</mat-label>
          <mat-select [(ngModel)]="idProyecto">
            <mat-option>
              <ngx-mat-select-search [formControl]="proyecto" [placeholderLabel]="'Buscar proyecto'" [noEntriesFoundLabel]="'No existe proyecto'">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let e of filterProyecto | async" [value]="e.id">{{ e.nombre }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="table-page__filter table-page__filter--wide">
        <mat-form-field appearance="outline" class="table-page__field">
          <mat-label>Colaborador</mat-label>
          <mat-select [(ngModel)]="idColaboladorProyecto">
            <mat-option>
              <ngx-mat-select-search [formControl]="colaborador" [placeholderLabel]="'Buscar colaborador'" [noEntriesFoundLabel]="'No existe colaborador'">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let x of filterProyectoEmpleado | async" [value]="x.usuario.id">
              {{ x.persona.nombreCompleto }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="table-page__filter table-page__filter--narrow">
        <mat-form-field appearance="outline" class="table-page__field">
          <mat-label>Fecha inicio</mat-label>
          <input class="colorInput" [(ngModel)]="modelFechaInicioProy" matInput readonly [matDatepicker]="dpInicioReportProy" (dateChange)="consultaListaSemanalProy()" [min]="minDateProy" [max]="ahora" aria-label="Fecha inicio">
          <mat-datepicker-toggle matSuffix [for]="dpInicioReportProy"></mat-datepicker-toggle>
          <mat-datepicker #dpInicioReportProy></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="table-page__filter table-page__filter--narrow">
        <mat-form-field appearance="outline" class="table-page__field">
          <mat-label>Fecha fin</mat-label>
          <input class="colorInput" [(ngModel)]="modelFechaFinProy" matInput readonly [matDatepicker]="dpFinReportProy" (dateChange)="consultaListaSemanalProy()" [min]="minDateProy" [max]="ahora" aria-label="Fecha fin">
          <mat-datepicker-toggle matSuffix [for]="dpFinReportProy"></mat-datepicker-toggle>
          <mat-datepicker #dpFinReportProy></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="table-page__toolbar-actions">
      <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="limpiarFormularioReporteProyecto()">
        <mat-icon>cleaning_services</mat-icon>
        Limpiar
      </button>
      <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="filtro2()">
        <mat-icon>search</mat-icon>
        Consultar
      </button>
    </div>
  </div>

  <div class="reporte-proyecto-page__actions">
    <small class="table-page__subtext">El total excluye tiempo rechazado y separa el pendiente fuera del consolidado.</small>
    <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="descargarReporteByProyecto()">
      <mat-icon>cloud_download</mat-icon>
      Descargar reporte
    </button>
  </div>

  <div class="table-page__table-wrap">
    <table class="table-page__table table-page__table--wide" *ngIf="listaProyectoGrid?.length; else emptyProyectoReport">
      <thead>
        <tr>
          <th>Proyecto</th>
          <th>Colaborador</th>
          <th>Horas validadas</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let row of listaProyectoGrid
              | paginate
                : {
                    id: 'reporteProyectoHoras',
                    itemsPerPage: pageSize,
                    currentPage: currentPageReporteProyecto,
                    totalItems: totalRegistros
                  }
          "
        >
          <td>{{ row.nombre }}</td>
          <td>
            <div class="table-page__cell-stack">
              <ng-container *ngFor="let colaborador of row.colaboradores; let last = last">
                <span *ngIf="!idColaboladorProyecto || colaborador.usuario.id === idColaboladorProyecto">
                  {{ colaborador.persona.nombreCompleto }}<span *ngIf="!last && (!idColaboladorProyecto || colaborador.usuario.id === idColaboladorProyecto)">, </span>
                </span>
              </ng-container>
            </div>
          </td>
          <td>{{ row.horasTotl }}</td>
        </tr>
      </tbody>
    </table>

    <ng-template #emptyProyectoReport>
      <div class="table-page__empty">
        <i class="material-icons">analytics</i>
        <strong>No hay consolidado por proyecto para los filtros seleccionados</strong>
        <span>Ajusta el rango o el proyecto para consultar otra combinación.</span>
      </div>
    </ng-template>
  </div>

  <div class="table-page__footer" *ngIf="showPaginationReporteProyecto">
    <div class="table-page__meta">
      <span>Página {{ currentPageReporteProyecto }} de {{ totalPagesReporteProyecto || 1 }}</span>
    </div>
    <div class="table-page__pager table-page__pager--ngx">
      <pagination-controls
        [id]="'reporteProyectoHoras'"
        responsive="true"
        class="my-pagination"
        [directionLinks]="true"
        [autoHide]="false"
        [previousLabel]="labels.previousLabel"
        [nextLabel]="labels.nextLabel"
        [maxSize]="5"
        (pageChange)="consultaPaginaReporteProyecto($event)">
      </pagination-controls>
    </div>
  </div>

  <a class="reporte-proyecto-page__download-link" #downloadReporteExcell aria-label="Descargar archivo"></a>
</section>
